/* eslint-disable @typescript-eslint/no-explicit-any */
import { apiClient } from '@lib/api-client';
import { queryClient } from '@lib/react-query';
import { notifications } from '@mantine/notifications';
import useStore from '@store/index';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

export const createOffset = (
	data: any
): Promise<{
	response: any;
}> => {
	return apiClient.post('/offsets', data);
};

export const useCreateOffset = () => {
	const { t } = useTranslation();
	const {
		setOffsetOpenDrawer,
		setOffsetCreationActiveStep,
		setOffsetAdditionalProjects,
		setOffsetAdditionalProjectsSelected,
		setOffsetMesurabilityProjects,
		setOffsetMesurabilityProjectsSelected,
		setOffsetProjectMixinAco2,
		setOffsetProjectMixinAddi,
		setOffsetStep2Error,
		setOffsetStep3Error,
		setOffsetCreationDatas,
		setOffsetMesurabilityProjectsPage,
		setIsAddOffset,
		setSuccessModalOpened,
	} = useStore();
	const {
		mutate,
		isPending: isLoading,
		status,
		data: response,
	} = useMutation({
		mutationFn: createOffset,
		onSuccess: () => {
			setSuccessModalOpened(true);
			queryClient.invalidateQueries({
				queryKey: ['offsets'],
			});
		},
		onError: (error: any) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'var(--mantine-color-igluRed-9)',
			});
		},
	});

	return { mutate, isLoading, status, response };
};
